export default {"src":"/_next/static/media/whypod-icon5.b088d1ec.svg","height":47,"width":63};